import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pss-success',
  imports: [CommonModule],
  templateUrl: './pss-success.component.html',
  styleUrl: './pss-success.component.css'
})
export class PssSuccessComponent {
  @Input() text : string = 'บันทึกเรียบร้อย!'
  @Input() detail: string = 'ขอบคุณที่ใช้บริการ'
  @Input() timeIn : number = 3000

  @Output() close = new EventEmitter<boolean>()

  constructor() { }

  ngOnInit(): void {
    this.onCountdown()
  }

  onCountdown() {
    setTimeout(() => {
        this.close.emit(false);
      },
      this.timeIn
    );
  }
}
